import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_df153c26b2f7261b9c156364d92116b4/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useEffect, useRef, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { t } from '../../i18n';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Modal(param) {
    var _title = param.title, title = _title === void 0 ? '' : _title, content = param.content, btnCancelMsg = param.btnCancelMsg, btnOkMsg = param.btnOkMsg, onOk = param.onOk, onCancel = param.onCancel, onDidClose = param.onDidClose, wrapClass = param.wrapClass;
    var ref = useState({
        zIndex: 1001
    }), wrapStyle = ref[0], setWrapStyle = ref[1];
    var refWrap = useRef(null);
    var onCurClose = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.t0 = onCancel;
                        if (!_ctx.t0) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 5;
                        return onCancel();
                    case 5:
                        _ctx.t0 = _ctx.sent;
                    case 6:
                        _ctx.t1 = _ctx.t0;
                        if (_ctx.t1) {
                            _ctx.next = 9;
                            break;
                        }
                        console.log('lose Modal Success');
                    case 9:
                        onDidClose();
                        _ctx.next = 14;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t2 = _ctx["catch"](0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function onCurClose() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        var resizeHandle = function() {
            if (refWrap && refWrap.current) {
                setWrapStyle({
                    top: '50%',
                    left: '50%',
                    zIndex: 1001,
                    transform: 'translate(-50%, -50%)'
                });
            }
        };
        window.addEventListener('resize', resizeHandle);
        resizeHandle();
        return function() {
            window.removeEventListener('resize', resizeHandle);
        };
    }, []);
    return(/*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "c-dialog ".concat(wrapClass),
                style: wrapStyle,
                ref: refWrap,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "c-dialog-hd",
                        children: /*#__PURE__*/ _jsx("a", {
                            className: "c-dialog-hd-close",
                            href: "javascript:;",
                            title: "Closse",
                            onClick: onCurClose,
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "Close"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "c-dialog-bd",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "c-dialog-confirm",
                            children: [
                                /*#__PURE__*/ _jsx("strong", {
                                    className: "c-dialog-confirm-title",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "c-dialog-confirm-desc",
                                    children: content
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "c-dialog-ft",
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "javascript:void(null);",
                                className: "c-dialog-ft-btn c-dialog-ft-btn-sumbit",
                                onClick: _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.prev = 0;
                                                _ctx.t0 = onOk;
                                                if (!_ctx.t0) {
                                                    _ctx.next = 5;
                                                    break;
                                                }
                                                _ctx.next = 5;
                                                return onOk();
                                            case 5:
                                                // console.log('Click Ok Success');
                                                onDidClose();
                                                _ctx.next = 10;
                                                break;
                                            case 8:
                                                _ctx.prev = 8;
                                                _ctx.t1 = _ctx["catch"](0);
                                            case 10:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            0,
                                            8
                                        ]
                                    ]);
                                })),
                                children: btnOkMsg || t('OK')
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "javascript:void(null);",
                                className: "c-dialog-ft-btn c-dialog-ft-btn-cancle",
                                onClick: onCurClose,
                                children: btnCancelMsg || t('Cancel')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "c-modal-mask",
                style: {
                    zIndex: 1000
                }
            })
        ]
    }));
}
export function confirm(props) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(/*#__PURE__*/ _jsx(Modal, _objectSpread({}, props, {
        onDidClose: function() {
            var unmountResult = ReactDOM.unmountComponentAtNode(div);
            if (unmountResult && div.parentNode) {
                div.parentNode.removeChild(div);
            }
        }
    })), div);
}
